import * as S from '@/pages/Home/style';
import mainBanner1 from '@/assets/img/banner/1.png';
import conferenceImg from '@/assets/img/2.png';
import greetingsImg from '@/assets/img/3.png';
import fuone from '@/assets/img/4_1.png';
import futwo from '@/assets/img/4_2.png';
import futhree from '@/assets/img/4_3.png';
import pinImg from '@/assets/img/pin.svg';
import busImg from '@/assets/img/bus.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { CardContainer } from '@/components/common/Card/CardContainer/style';
import Person from '@/assets/img/icon/personIcon.svg';
import GlassIcon from '@/assets/img/icon/glassIcon.svg';
import ChartIcon from '@/assets/img/icon/chartIcon.svg';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import { useGetBasicApi } from '@/api/basic';

const Home = () => {
	const navigate = useNavigate();
	const isMobile = useIsMobile(1100);
	const { data: basicData } = useGetBasicApi();

	useEffect(() => {
		const appKey = import.meta.env.VITE_KAKAO_APP_KEY as string | undefined;
		if (!appKey) {
			console.warn('VITE_KAKAO_APP_KEY is not set. Kakao Map will not be initialized.');
			return;
		}

		const scriptId = 'kakao-map-sdk';
		const existingScript = document.getElementById(scriptId) as HTMLScriptElement | null;

		const initializeMap = () => {
			const kakaoGlobal = (window as any).kakao;
			if (!kakaoGlobal || !kakaoGlobal.maps) return;

			const container = document.getElementById('map');
			if (!container) return;

			const defaultCenter = new kakaoGlobal.maps.LatLng(37.5117, 127.0739); // 잠실 일대 대략 좌표 (fallback)
			const map = new kakaoGlobal.maps.Map(container, {
				center: defaultCenter,
				level: 3,
			});

			// 주소로 좌표 검색 후 표시
			const address = '서울 송파구 올림픽로 82';
			if (kakaoGlobal.maps.services) {
				const geocoder = new kakaoGlobal.maps.services.Geocoder();
				geocoder.addressSearch(address, (result: any, status: any) => {
					if (status === kakaoGlobal.maps.services.Status.OK && result?.[0]) {
						const coords = new kakaoGlobal.maps.LatLng(Number(result[0].y), Number(result[0].x));
						map.setCenter(coords);
						new kakaoGlobal.maps.Marker({ map, position: coords });
					} else {
						new kakaoGlobal.maps.Marker({ map, position: defaultCenter });
					}
				});
			} else {
				new kakaoGlobal.maps.Marker({ map, position: defaultCenter });
			}
		};

		if (existingScript && (window as any).kakao && (window as any).kakao.maps) {
			(window as any).kakao.maps.load(initializeMap);
			return;
		}

		const script = existingScript ?? document.createElement('script');
		script.id = scriptId;
		script.async = true;
		script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${appKey}&autoload=false&libraries=services`;
		script.onload = () => {
			(window as any).kakao.maps.load(initializeMap);
		};
		if (!existingScript) {
			document.head.appendChild(script);
		}

		// 스크립트는 한 번만 로드하고 유지. 별도 cleanup 불필요.
	}, []);
	return (
		<S.MainWrapper>
			<div className="container">
				<S.MainBanner>
					<Swiper
						modules={[Navigation, Pagination, Autoplay]}
						slidesPerView={1}
						spaceBetween={0}
						navigation
						pagination={{
							clickable: true,
							el: '.swiper-pagination_custom .swiper-pagination',
						}}
						autoplay={{
							delay: 4000,
							disableOnInteraction: false,
						}}
						loop={true}
						style={{ width: '100%', height: '100%' }}
					>
						<SwiperSlide className="first">
							<img src={mainBanner1} alt="img3" className="first_background" />
							<div className="textBoxWrapper">
								<div className="textBox">
									<h1 className="title">TYCHE는 운명, 행복, 기회를 뜻합니다.</h1>
									<p className="description">투자자분들과 만날 운명 그리고 투자를 통한 행복의 기회를 드리고자 책임을 다하는 Tyche Partners가 되겠습니다.</p>
								</div>
							</div>
						</SwiperSlide>
						<div className="swiper-pagination_custom">
							<div className="swiper-pagination" />
						</div>
					</Swiper>
				</S.MainBanner>
			</div>
			<S.Description compactBottom>
				<div className="main_description_title">
					<h2 className="description_title">회사개요</h2>
					<p className="description_sub_title">
						{' '}
						Tyche Partners 주식회사는 인수합병, 기업구조조정, 부실채권 인수 등 고수익 투자시장에서 기업개선에 직접 참여하여 적극적 Value-up 전략을 통해
						투자기업의 가치를 제고하는데 핵심역량을 다하고 있으며, 다양한 경험의 운용인력들의 검증된 Track record를 보유하여 다양한 산업군의 기업에 투자 및
						가치를 창출하여 투자자들의 이익에 공헌하고자 합니다.{' '}
					</p>
				</div>
				<S.CardList>
					<CardContainer className={` border-right border-bottom`}>
						<S.CardWrapper>
							<S.CardTitle>검증된 투자 전문 인력</S.CardTitle>
							<S.CardSubTitle>
								평균 15년 이상 경력을 지닌
								<br />
								핵심 운용 인력이 포진
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={Person} alt="person" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer className={`border-right border-bottom`}>
						<S.CardWrapper>
							<S.CardTitle>
								고수익 특수시장에 <br style={!isMobile ? { display: 'none' } : {}} /> 특화된 전문성
							</S.CardTitle>
							<S.CardSubTitle>
								고수익 투자 분야에서의
								<br />
								풍부한 경험과 전략적 접근력
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={GlassIcon} alt="glass" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer className={` ${isMobile ? 'border-right' : ''} border-bottom`}>
						<S.CardWrapper>
							<S.CardTitle>
								산업 전반에 걸친 <br style={!isMobile ? { display: 'none' } : {}} /> 가치 창출 역량
							</S.CardTitle>
							<S.CardSubTitle>
								기업의 본질적 가치를 높이고,
								<br />
								투자자 수익 실현에 기여
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={ChartIcon} alt="chart" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
				</S.CardList>
			</S.Description>
			<S.Notice>
				<S.NoticeContent>
					<S.NoticeContentList>
						<S.CardImg bgImg={conferenceImg}>
							<div className="title_box">
								<div className="title">{basicData?.aum?.aum_title || '운용자산규모(AUM)'}</div>
								<div className="mid_title">{basicData?.aum?.aum_sub_title || '2,153억 원 (2024년 기준)'}</div>
								<div className="sub_title">
									<div dangerouslySetInnerHTML={{ __html: String(basicData?.aum?.aum_content) }} />
								</div>
							</div>
						</S.CardImg>
					</S.NoticeContentList>
				</S.NoticeContent>
			</S.Notice>
			<S.GreetingSection>
				<S.Description transparent>
					<div className="main_description_title">
						<h2 className="description_title">{basicData?.ceo?.ceo_title || '대표이사 인사말'}</h2>
					</div>
					<S.GreetingBox>
						<S.GreetingImg>
							<img src={basicData?.ceo?.ceo_image_url || greetingsImg} alt="대표 이미지" />
						</S.GreetingImg>
						<S.GreetingText>
							<S.GreetingNameRow>
								<S.GreetingName>이경익</S.GreetingName>
								<S.GreetingPosition>대표이사</S.GreetingPosition>
							</S.GreetingNameRow>
							<S.GreetingMessage>
								<div dangerouslySetInnerHTML={{ __html: String(basicData?.ceo?.ceo_content) }} />
							</S.GreetingMessage>
						</S.GreetingText>
					</S.GreetingBox>
				</S.Description>
			</S.GreetingSection>
			<S.Description compactBottom>
				<div className="main_description_title">
					<h2 className="description_title">운용 철학</h2>
					<p className="description_sub_title">
						{' '}
						타이키파트너스는 단기 수익을 넘어, 기업과 시장의 본질적 가치 성장에 집중합니다. 평균 15년 이상 경력을 지닌 전문가들이 정교한 전략과 철저한 리스크
						관리를 바탕으로, 고수익 시장에서도 안정적인 운용 성과를 추구합니다. 우리는 투자자와의 신뢰를 최우선 가치로 삼고, 투자 그 이상의 가치를 실현하는 책임
						있는 파트너로서 지속가능한 성장을 만들어가겠습니다.
					</p>
				</div>
				<S.FeatureRowGrid>
					<CardContainer className={` border-right border-bottom`}>
						<div className="feature-card">
							<S.CardWrapper>
								<S.CardTitle>전문성과 책임</S.CardTitle>
								<S.FeatureCardSubTitle>평균 15년 이상의 경험과 정교한 전략으로, 철저한 리스크 관리와 책임 있는 운용을 실천합니다.</S.FeatureCardSubTitle>
							</S.CardWrapper>
							<S.ImgBoxWrapper>
								<S.FeatureImgBox>
									<img src={fuone} alt="fuone" />
								</S.FeatureImgBox>
							</S.ImgBoxWrapper>
						</div>
					</CardContainer>

					<S.Plus />

					<CardContainer className={`border-right border-bottom`}>
						<div className="feature-card">
							<S.CardWrapper>
								<S.CardTitle>가치 중심의 장기 성장</S.CardTitle>
								<S.FeatureCardSubTitle>단기 수익보다 기업의 본질적 가치 상승과 지속 가능한 성장을 추구합니다.</S.FeatureCardSubTitle>
							</S.CardWrapper>
							<S.ImgBoxWrapper>
								<S.FeatureImgBox>
									<img src={futwo} alt="futwo" />
								</S.FeatureImgBox>
							</S.ImgBoxWrapper>
						</div>
					</CardContainer>

					<S.Plus />

					<CardContainer className={` ${isMobile ? 'border-right' : ''} border-bottom`}>
						<div className="feature-card">
							<S.CardWrapper>
								<S.CardTitle>투명한 신뢰 구축</S.CardTitle>
								<S.FeatureCardSubTitle>성과와 투명한 소통을 바탕으로 투자자와의 신뢰관계를 지켜갑니다.</S.FeatureCardSubTitle>
							</S.CardWrapper>
							<S.ImgBoxWrapper>
								<S.FeatureImgBox>
									<img src={futhree} alt="futhree" />
								</S.FeatureImgBox>
							</S.ImgBoxWrapper>
						</div>
					</CardContainer>
				</S.FeatureRowGrid>
			</S.Description>
			<S.DirectionsSection>
				<S.Description transparent compactBottom tightGap>
					<div className="main_description_title">
						<h2 className="description_title">오시는 길</h2>
						<p className="description_sub_title">
							{' '}
							타이키파트너스를 방문하시려면 아래 위치 정보를 참고해 주시기 바랍니다. 고객 여러분이 편리하게 찾아오실 수 있도록 정확한 안내를 제공해드리고
							있으며, 내방 전 문의를 주시면 보다 신속하고 친절하게 도와드리겠습니다. 보다 나은 파트너십과 상담을 위해 언제든 방문을 환영합니다.
						</p>
					</div>
					<S.DirectionsInner>
						<S.MapPanel>
							<div id="map" />
						</S.MapPanel>
						<S.AddressCardGroup>
							<S.AddressCard>
								<div className="title_wrap">
									<img className="icon" src={pinImg} alt="핀" />
									<span className="title">주소</span>
								</div>
								<ul className="c_info_list">
									<li className="item">서울 송파구 올림픽로 82, 8층(잠실동, 현대빌딩)</li>
								</ul>
							</S.AddressCard>
							<S.AddressCard>
								<div className="title_wrap">
									<img className="icon" src={busImg} alt="버스" />
									<span className="title">대중교통</span>
								</div>
								<ul className="c_info_list">
									<li className="item subway">
										<strong>종합운동장역 2호선</strong> 1번출구로 나오셔서 약 1분 직진 후 우측에 잠실현대빌딩 8층
									</li>
									<li className="item bus bus--blue">
										<strong>간선버스</strong>301, 333, 341, 342, 345, 360
									</li>
									<li className="item bus bus--green">
										<strong>지선버스</strong>2415, 3217, 3322, 3411, 3412, 3414, 3422, 4318, 4319
									</li>
								</ul>
							</S.AddressCard>
						</S.AddressCardGroup>
					</S.DirectionsInner>
				</S.Description>
			</S.DirectionsSection>
		</S.MainWrapper>
	);
};

export default Home;
